import { apiSlice } from '../../api/apiSlice';
import { ADMIN_NOTIFICATION_TEMPLATE, ADMIN_NOTIFICATION_TEMPLATE_CREATE, ADMIN_NOTIFICATION_TEMPLATE_UPDATE } from '../../constants';

export const MessagingSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getAdminNotifications: builder.query({
            query: () => {
                return {
                    url: ADMIN_NOTIFICATION_TEMPLATE,
                };
            },
            providesTags: ['AdminNotification']
        }),
        createAdminNotification: builder.mutation({
            query: (arg: any) => {
                return {
                    url: ADMIN_NOTIFICATION_TEMPLATE_CREATE,
                    method: 'POST',
                    body: arg,
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                    },
                };
            },
            invalidatesTags: ['AdminNotification'],
        }),
        updateAdminNotification: builder.mutation({
            query: (arg: any) => {
                return {
                    url: ADMIN_NOTIFICATION_TEMPLATE_UPDATE,
                    method: 'PUT',
                    body: arg,
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                    },
                };
            },
            invalidatesTags: ['AdminNotification'],
        }),
    })
});

export const {
    useGetAdminNotificationsQuery,
    useCreateAdminNotificationMutation,
    useUpdateAdminNotificationMutation
} = MessagingSlice;